/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import Model, { attr } from '@ember-data/model';
import { ajaxDelete } from 'embercom/lib/ajax';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

const API_ROOT = '/ember/standalone/salesforce_in_app_messaging_configurations';

export default class SalesforceInAppMessagingConfiguration extends Model {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: AppService;

  @attr('string') declare organizationId: string | undefined;
  @attr('string') declare deploymentId: string | undefined;
  @attr('string') declare hostname: string | undefined;
  @attr('boolean') declare userVerificationEnabled: boolean | undefined;
  @attr() declare jwk: Record<string, string> | undefined;

  get isPendingSetup() {
    return !this.organizationId || !this.deploymentId || !this.hostname;
  }

  get isConnected() {
    return !this.isPendingSetup;
  }

  async revoke() {
    await ajaxDelete(`${API_ROOT}/${this.id}`);
    this.organizationId = undefined;
    this.deploymentId = undefined;
    this.hostname = undefined;
    this.userVerificationEnabled = undefined;
    this.jwk = undefined;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'standalone/salesforce-in-app-messaging-configuration': SalesforceInAppMessagingConfiguration;
  }
}
